// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#renderCanvas{transition:filter 1s ease;outline:none}.render-level *{box-sizing:content-box!important}", ""]);
// Exports
module.exports = exports;
